<template>
  <v-row class="planner-layout" no-gutters>
    <div v-show="toggleFlag === 'default'" :style="[cardBackLogToggle ? {position: 'absolute', top: '2%', left: '0.2%', zIndex: '9'} : {potision: 'relative', width: '48px', height: '100%'}]">
      <v-btn :style="[cardBackLogToggle ? {} : {position: 'absolute', top: '2%', left: '0.2%'}]"  @click="cardBackLogToggle = !cardBackLogToggle" icon small class="ma-0">
        <v-icon :size="18" color="primary">{{cardBackLogToggle ? 'fa-th' : 'fa-th-list'}}</v-icon>
      </v-btn>
    </div>
    <template>
      <div
      :style="[toggleFlag !== 'backlog_filters' ? 'width: 20%;' : 'width: 50%;']"
      v-show="cardBackLogToggle && (toggleFlag === 'backlog_filters' || toggleFlag === 'default')"
      class="planner-layout__backlog"
      >
        <v-container class="px-0 pt-3" style="min-width: 260px;">
              <AlgoliaInstanceBackLog
              :key="$route.query.day"
              v-if="plannerShipmentIDs != null"
              :isFiltersVisible="toggleFlag === 'backlog_filters'"
              :algoliaIndex="'prod_drops_v2'"
              >
                <template #hits>
                  <SortableInstanceBackLogDrops :handleToggleView="handleToggleOptions"/>
                </template>
                <template #filters>
                  <v-card v-show="toggleFlag === 'backlog_filters'" class="planner-layout__backlog-filters overflow-y-auto pa-0">
                    <v-card-title class="text-center">
                      <span class="headline">{{$t('planner.backlog_filters')}}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <div>
                        <BacklogAlgoliaFilters/>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </AlgoliaInstanceBackLog>
        </v-container>
    </div>
    </template>
    <div id="plannerShipmentsContainer" v-show="toggleFlag === 'default' || toggleFlag === 'shipment_filters' " class="planner-layout__shipments pl-1 pr-0 py-0">
      <v-row
      id="plannerContainer"
      class="draggable_list_container pl-2 pt-2 pb-0 pr-0"
      no-gutters
      >
        <div v-show="toggleFlag === 'default'"
        :key="shipment" v-for="(shipment, shipmentIndex) in shipmentsArray">
          <SortableInstanceShipmentDrops :handleDeleteShipment="handleDeleteShipment" :shipment="{shipmentID: shipment}" :shipmentIndex="shipmentIndex.toString()"/>
        </div>
      </v-row>
      <div
        class="shipment--actions"
      >
        <ShipmentActions
          v-show="toggleFlag === 'default' || toggleFlag === 'shipment_filters'"

        />
      </div>
    </div>
    <v-dialog
      v-model="isSavingPlanner"
      width="500"
      :persisten="true"
    >
      <v-card>
        <v-card-text class="text-center">
          <span class="title">{{$t('planner.saving_process')}}</span>
           <v-progress-linear color="primary" :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isOptimizingPlanner"
      width="500"
      :persisten="true"
    >
      <v-card>
        <v-card-text class="text-center">
          <span class="title">{{$t('planner.optimize_process')}}</span>
           <v-progress-linear color="primary" :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isInitializingPlanner"
      width="500"
      :persisten="true"
    >
      <v-card>
        <v-card-text class="text-center">
          <span class="title">{{$t('planner.initialize_process')}}</span>
           <v-progress-linear color="primary" :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <ShipmentsScrollMap v-show="toggleFlag === 'default'" :reCalculateVisible="cardBackLogToggle" :idElements="shipmentsArray.map(({ shipmentID }) => shipmentID)"/> -->
  </v-row>
</template>
<script>
import AlgoliaInstanceBackLog from '@/components/planner/AlgoliaInstanceBackLog.vue'
import BacklogAlgoliaFilters from '@/components/planner/BacklogAlgoliaFilters.vue'
import SortableInstanceBackLogDrops from '@/components/planner/SortableInstanceBackLogDrops.vue'
import SortableInstanceShipmentDrops from '@/components/planner/SortableInstanceShipmentDrops.vue'
import ShipmentActions from '@/components/planner/ShipmentActions.vue'
import { mapActions, mapGetters } from 'vuex'
import { algoliaService } from '@/_services'
import Sortable from 'sortablejs'
export default {
  name: 'PlannerDrops',
  components: {
    AlgoliaInstanceBackLog,
    SortableInstanceBackLogDrops,
    SortableInstanceShipmentDrops,
    ShipmentActions,
    BacklogAlgoliaFilters
  },
  data () {
    return {
      toggleFlag: 'default',
      cardBackLogToggle: true,
      draggableContainers: null,
      plannerShipmentIDs: null
    }
  },
  created () {},
  mounted () {
    this.handleInitialization()
  },
  methods: {
    ...mapActions({
      removeShipment: 'removeShipment',
      addNewShipment: 'addNewShipment',
      newPlannerDoc: 'newPlannerDoc',
      setVisibleShipments: 'setVisibleShipments',
      createNewShipment: 'createNewShipment',
      setPlannerLocations: 'setPlannerLocations',
      setPlannerDrops: 'setPlannerDrops',
      setDropsFromShipmentsArray: 'setDropsFromShipmentsArray',
      setPlannerInitializing: 'setPlannerInitializing',
      setPlannerDoc: 'setPlannerDoc'
    }),
    handleToggleOptions (toggleCardName) {
      this.toggleFlag = toggleCardName
    },
    initializeDraggableContainer () {
      this.draggableContainers = Sortable.create(document.querySelector('.draggable_list_container'), {
        group: {
          name: 'container'
        },
        forceFallback: true,
        filter: '.disableDrag',
        ghostClass: 'drop-ghost',
        delay: 100,
        store: {
          get: (sortable) => {
          },
          set: (sortable) => {
          }
        }
      })
    },
    handleNewShipmentCreation ({ labels, departureDate }) {
      this.createNewShipment({ labels, departureDate })
    },
    handleDeleteShipment (index, shipment) {
      this.removeShipment({ shipmentID: shipment.shipmentID })
      // this.deleteShipment = this.shipmentsArray[index].shipmentName
      // this.shipmentsArray.splice(index, 1)
    },
    handleInitialization () {
      const doc = this.getPlannerDoc
      const day = this.$route.query.day
      const shipmentIDs = this.$route.query.shipmentIDs
      this.setPlannerInitializing({ flag: true })
      this.setVisibleShipments({ shipmentIDs })
      if (doc === null) {
        algoliaService.getShipmentsForSpecificDay({ day }).then((shipments) => {
          this.plannerShipmentIDs = shipments.map(({ objectID }) => objectID)
          this.newPlannerDoc({ docDay: day, shipments })
          this.setDropsFromShipmentsArray({ shipments })
          this.$nextTick(() => {
            this.initializeDraggableContainer()
          })
        }).catch((error) => {
          console.error(error)
        })
      } else if (doc.docDay !== day) {
        algoliaService.getShipmentsForSpecificDay({ day }).then((shipments) => {
          this.plannerShipmentIDs = shipments.map(({ objectID }) => objectID)
          this.newPlannerDoc({ docDay: day, shipments })
          this.setDropsFromShipmentsArray({ shipments })
          this.$nextTick(() => {
            this.initializeDraggableContainer()
          })
        }).catch((error) => {
          console.error(error)
        })
      } else {
        algoliaService.getShipmentsForSpecificDay({ day }).then((shipments) => {
          this.plannerShipmentIDs = shipments.map(({ objectID }) => objectID)
          this.$nextTick(() => {
            this.initializeDraggableContainer()
            this.setPlannerInitializing({ flag: false })
          })
        }).catch((error) => {
          console.error(error)
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerDoc',
      'getPlannerShipments',
      'getPlannerVisibleShipments',
      'getPlannerLocations',
      'getPlannerDrops',
      'getPlannerCards',
      'getPlannerIsSaving',
      'getPlannerIsOptimizing',
      'getPlannerIsInitializing'
    ]),
    shipmentsArray: function () {
      return this.getPlannerVisibleShipments
    },
    isSavingPlanner () {
      return this.getPlannerIsSaving
    },
    isOptimizingPlanner () {
      return this.getPlannerIsOptimizing
    },
    isInitializingPlanner () {
      return this.getPlannerIsInitializing
    }
  },
  watch: {
    isSavingPlanner: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (!val && oldVal) {
          // this.handleInitialization()
        }
      }
    },
  },
  beforeDestroy () {
    this.setVisibleShipments({ shipmentIDs: [] })
    this.setPlannerDoc({ doc: null })
    if (this.draggableContainers !== null) {
      this.draggableContainers.destroy()
    }
  }
}
</script>
<style lang="scss" scoped>
.draggable_list_container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.shipment--actions {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
